import GameScene from "../scenes/GameScene";
import { HiddenObject } from "./HiddenObject";
import { HiddenObjectLevel } from "./HiddenObjectLevel";

export interface HiddenObjectGameData {
	id: string;
	title: string;
	objects: number;
}

export class HiddenObjectGame {
	static ON_LEVEL_START = "ON_LEVEL_START";
	static ON_LEVEL_COMPLETE = "ON_LEVEL_COMPLETE";

	events: Phaser.Events.EventEmitter;
	scene: GameScene;

	currentLevel: HiddenObjectLevel;
	levelStartTimer: number;

	background: Phaser.GameObjects.Container;
	bgLayers: Phaser.GameObjects.Container[];
	bgImages: Phaser.GameObjects.Image[];

	protected justUnlocked: number;
	protected levelsCompleted: number;

	isPaused: boolean;

	data: HiddenObjectGameData;

	private newObjectTimer = 0;

	constructor(scene: GameScene, data: HiddenObjectGameData) {
		this.scene = scene;
		this.data = data;
		this.bgLayers = [];
		this.bgImages = [];

		this.events = new Phaser.Events.EventEmitter();

		this.levelsCompleted = 0;
		this.justUnlocked = -1;
		this.bgLayers = [];

		const background = (this.background = scene.add.container(0, 0));
		scene.gameContainer.addAt(background, 0);

		this.isPaused = true;
	}

	loadNextLevel(levelKey: string): void {
		if (this.currentLevel) {
			this.currentLevel.destroy();
		}

		const levelConfig = {
			objects: this.data.objects,
		};

		console.log(levelKey);
		this.currentLevel = new HiddenObjectLevel(this.scene.cache.json.get(levelKey), this.scene, levelConfig);

		this.currentLevel.events.addListener(HiddenObjectLevel.ON_OBJECT_COLLECTED, this.onObjectCollected, this);
		this.currentLevel.events.once(HiddenObjectLevel.ON_LEVEL_COMPLETED, this.onLevelCompleted, this);

		this.levelStartTimer = 0;
		this.justUnlocked = -1;
		this.events.emit(HiddenObjectGame.ON_LEVEL_START);

		this.revealNextObject();
	}

	update(time: number, delta: number): void {
		if (this.isPaused == false) {
			delta /= 1000;

			this.levelStartTimer += delta;

			if (this.newObjectTimer >= 0) {
				this.newObjectTimer -= delta;
				if (
					this.newObjectTimer < 0 &&
					this.currentLevel.objectsEnabled < this.data.objects &&
					this.scene.hiddenObjBar.checkSpaceAvailable()
				) {
					this.revealNextObject();
				}
			}

			this.currentLevel.hiddenObjects.forEach((object) => {
				object.update(delta);
			});
		}
	}

	createBGLayers(background: string[]): void {
		this.bgLayers.forEach((c) => {
			if (c) c.destroy();
		});
		this.bgLayers = [];
		this.bgImages = [];
		this.background.removeAll();

		if (background && background.length > 0) {
			background.forEach((img) => this.addBGLayer(img));
		} else {
			this.addBGLayer("env1-1-1");
		}
		this.scene.resize();
	}

	getLastBGLayer(): Phaser.GameObjects.Container {
		return this.bgLayers[this.bgLayers.length - 1];
	}

	revealNextObject(): void {
		const obj = this.currentLevel.enableNextHiddenObject();
		const rawKey = obj.image.texture.key;
		let sliceFromBack = 0;
		if (rawKey.search("day") > 0) {
			sliceFromBack = -8;
		} else {
			sliceFromBack = -10;
		}
		const newKey = rawKey.slice(9, sliceFromBack) + "1";
		console.log("grabbing " + newKey);
		this.scene.hiddenObjBar.addThumbnail(newKey, obj.id);
		this.newObjectTimer = 10;
	}

	protected addBGLayer(bgImage: string): void {
		const layer = this.scene.add.container(0, 0);
		const bg = this.scene.add.image(0, 0, bgImage);
		layer.add(bg);

		this.bgLayers.push(layer);
		this.bgImages.push(bg);
		this.background.add(layer);
		this.background.setSize(bg.width, bg.height);
		//this.scene.gameContainer.setSize(bg.width, bg.height);
	}

	resizeBG(): void {
		if (this.bgImages.length == 0) return;
		this.bgImages.forEach((bg, index) => {
			const layer = this.bgLayers[index];
			if (layer) this.scene.alignIn.Center(layer, this.background, -bg.width / 2, -bg.height / 2);
			if (bg && layer) this.scene.alignIn.Center(bg, this.background, -layer.x, -layer.y);
		});
	}

	addHiddenObject(obj: Phaser.GameObjects.Image, layer: number): void {
		const children = this.bgLayers[layer].getAll();
		// Don't include the background in the search
		if (children.length > 1) {
			for (let i = children.length - 1; i > 0; i--) {
				const img = children[i] as Phaser.GameObjects.Image;
				if (img && obj.y > img.y) {
					this.bgLayers[layer].addAt(obj, i + 1);
					return;
				}
			}
			this.bgLayers[layer].addAt(obj, 1);
		} else {
			this.bgLayers[layer].add(obj);
		}
	}

	startGame(): void {
		this.isPaused = false;
	}

	protected onObjectCollected(hiddenObject: HiddenObject): void {
		this.newObjectTimer = 0;
		this.scene.hiddenObjBar.onFindObject(hiddenObject.id);
		// this.scene.addScore(this.config.pointsPerObject);
		// this.scene.updateObjRemaining();
	}

	protected onLevelCompleted(): void {
		this.events.emit(HiddenObjectGame.ON_LEVEL_COMPLETE);
	}
}
